import { render, staticRenderFns } from "./MenuCard.vue?vue&type=template&id=2972be73&scoped=true&"
import script from "./MenuCard.vue?vue&type=script&lang=js&"
export * from "./MenuCard.vue?vue&type=script&lang=js&"
import style0 from "./MenuCard.vue?vue&type=style&index=0&id=2972be73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2972be73",
  null
  
)

export default component.exports